import React from 'react';

const RewardCounter = ({ correctCount, incorrectCount }) => {
  const doudous = ['🧸', '🐻', '🐼', '🦁', '🐯', '🐰', '🦊', '🐨', '🐶', '🐱'];

  // Sélectionner des doudous aléatoires pour les bonnes réponses
  const getRandomDoudou = (index) => {
    return doudous[index % doudous.length];
  };

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      padding: '15px',
      borderRadius: '12px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      maxWidth: '180px',
      zIndex: 1000,
      fontSize: '0.9rem'
    }}>
      <div style={{
        textAlign: 'center',
        marginBottom: '10px',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#667eea'
      }}>
        🏆 Score
      </div>

      {/* Bonnes réponses avec doudous */}
      <div style={{
        marginBottom: '10px',
        padding: '8px',
        backgroundColor: '#e8f5e9',
        borderRadius: '8px'
      }}>
        <div style={{
          fontSize: '0.85rem',
          fontWeight: 'bold',
          color: '#4CAF50',
          marginBottom: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <span>✅ Bonnes</span>
          <span style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem'
          }}>
            {correctCount}
          </span>
        </div>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '3px',
          minHeight: '35px',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          {correctCount === 0 ? (
            <span style={{ fontSize: '0.75rem', color: '#999' }}>Aucun doudou</span>
          ) : (
            Array.from({ length: Math.min(correctCount, 6) }).map((_, index) => (
              <span
                key={index}
                style={{
                  fontSize: '1.5rem',
                  animation: 'bounce 0.5s ease',
                  display: 'inline-block'
                }}
              >
                {getRandomDoudou(index)}
              </span>
            ))
          )}
          {correctCount > 6 && (
            <span style={{ fontSize: '0.8rem', color: '#4CAF50', fontWeight: 'bold' }}>
              +{correctCount - 6}
            </span>
          )}
        </div>
      </div>

      {/* Mauvaises réponses */}
      <div style={{
        padding: '8px',
        backgroundColor: '#ffebee',
        borderRadius: '8px'
      }}>
        <div style={{
          fontSize: '0.85rem',
          fontWeight: 'bold',
          color: '#f44336',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <span>❌ Erreurs</span>
          <span style={{
            backgroundColor: '#f44336',
            color: 'white',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem'
          }}>
            {incorrectCount}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RewardCounter;
